import { useDispatch, useSelector } from 'react-redux';
import { selectEmail, selectPhoneNumber, selectShowInvalids } from '@store/partners-order/selectors';
import { setEmail, setPhoneNumber } from '@store/partners-order/slice';
import TextField from '@components/text-field/TextField';
import { isValidEmail, isValidPhoneNumber } from '@components/utils';



const ContactInfo = (): JSX.Element => {

	const email = useSelector(selectEmail);
	const phoneNumber = useSelector(selectPhoneNumber);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateEmail = (value: string | null) => dispatch(setEmail(value));
	const updatePhoneNumber = (value: string | null) => dispatch(setPhoneNumber(value));

	return (
		<div className='contact-info-section'>

			<TextField
				label='E-mail'
				value={email ? email : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateEmail(null) : updateEmail(value)}
				errorMessage={showInvalids && email && email.length > 0 && !isValidEmail(email) ? 'Neznámý formát e-mailu' : undefined} />

			<TextField
				label='Telefon'
				value={phoneNumber ? phoneNumber : undefined}
				rounded={true}
				maxLength={16}
				onChange={(value: string) =>
					!value && value.length === 0 ? updatePhoneNumber(null) : updatePhoneNumber(value)}
				errorMessage={showInvalids && phoneNumber && phoneNumber.length > 0 && !isValidPhoneNumber(phoneNumber) ? 'Neznámý formát telefonního čísla' : undefined} />

		</div>
	);
};

export default ContactInfo;